(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/optional-browser-router.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/optional-browser-router.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  BrowserRouter = _ReactRouterDOM.BrowserRouter;
const OptionalBrowserRouter = _ref => {
  let children = _ref.children,
    isEnclosedInRouter = _ref.isEnclosedInRouter,
    basename = _ref.basename;
  if (!isEnclosedInRouter) {
    return React.createElement(BrowserRouter, {
      basename: basename
    }, children);
  }
  return children;
};
setGlobal('svs.components.sportinfo.bigstat.OptionalBrowserRouter', OptionalBrowserRouter);

 })(window);